<template>
    <div id="app">
        <index> </index>
    </div>
</template>

<script>
import index from "./components/share.vue";

export default {
    name: "App",
    components: {
        index,
    },
};
</script>

<style>
* {
    margin: 0px;
    padding: 0px;
    -webkit-tap-highlight-color: transparent;
    /* -webkit-text-size-adjust: none;  */
}
body,
html,
#app {
    width: 100%;
    height: 100%;
}
</style>
